import { apiGet, apiPost, apiPut, parseJsonResponse } from './apiClient';

export const postBewertungsobjekt = async (gutachtenID, duplicateID = 0) => {
  try {
    let BObody;
    if (duplicateID !== 0) {
      const res = await apiGet(`/helper/acl/bewertungsobjekt/${duplicateID}?populate=deep`);
      const data = await parseJsonResponse(res);
      BObody = { data: { ...data } };
      delete BObody.data.id;
      delete BObody.data.createdAt;
      BObody.data.Wertermittlung.Berechnungsexcel = null;
    } else {
      BObody = {
        data: {
          Wertermittlung: { Verkehrswert: {} },
          Gebaeude_AA: {
            Einheiten_KGA: {},
            Gebauede_Aussenanlage: {},
            MieteUndKosten: {},
          },
        },
      };
    }

    const resBO = await apiPost('/helper/acl/bewertungsobjekt', BObody.data);
    if (!resBO.ok) throw new Error('Fehler beim Erstellen des Bewertungsobjekts.');

    const { id: BOID } = await parseJsonResponse(resBO);
    const connectRes = await apiPut(`/helper/acl/gutachten/${gutachtenID}`, {
      bewertungsobjekts: { connect: [BOID] },
    });
    if (!connectRes.ok) throw new Error('Fehler beim Verknüpfen des Bewertungsobjekts.');

    return { id: BOID };
  } catch (error) {
    console.error('Fehler:', error);
    return { error: error.message };
  }
};

export const postGutachten = async (auftragID, duplicateID = 0) => {
  try {
    let body;
    if (duplicateID !== 0) {
      const res = await apiGet(`/helper/acl/gutachten/${duplicateID}?populate=deep`);
      const data = await parseJsonResponse(res);
      body = { data: { ...data } };
      delete body.data.bewertungsobjekts;
      delete body.data.id;
      body.data.AllgAng.Unterlagen = [];
      Object.keys(body.data.Anlagen).forEach((key) => {
        body.data.Anlagen[key] = [];
      });
    } else {
      body = {
        data: {
          AllgAng: { AllgAng_Detail: {} },
          Lage: { Wirtschaftsdaten: {} },
          Anlagen: {},
          Grundstueck: {},
          Gebaeude_AA: {
            Einheiten_KGA: {},
            Gebauede_Aussenanlage: {},
            MieteUndKosten: {},
          },
          Wertermittlung: { Verkehrswert: {} },
        },
      };
    }

    const resGutachten = await apiPost('/helper/acl/gutachten/', body.data);
    if (!resGutachten.ok) throw new Error('Fehler beim Erstellen des Gutachtens.');

    const { id: gutachtenID } = await parseJsonResponse(resGutachten);
    const connectRes = await apiPut(`/helper/acl/auftrag/${auftragID}`, {
      gutachtens: { connect: [gutachtenID] },
    });
    if (!connectRes.ok) throw new Error('Fehler beim Verknüpfen des Gutachtens.');

    return { id: gutachtenID };
  } catch (error) {
    console.error('Fehler:', error);
    return { error: error.message };
  }
};

export const createAuftragExecute = async (userKonfiguration, navigate, duplicatedAuftrag = 0) => {
  try {
    const resNr = await apiGet('/helper/acl/auftrag/?sort=createdAt:asc&pagination[limit]=1');
    const nrBody = await parseJsonResponse(resNr);

    let prevAuftragsnummer;
    if (nrBody[nrBody.length - 1]) {
      if (userKonfiguration.OrderNumeration === 'PerYear') {
        const yearPrev = new Date(nrBody[nrBody.length - 1].createdAt).getFullYear();
        prevAuftragsnummer =
          yearPrev < new Date().getFullYear()
            ? new Date().getFullYear() + '-0'
            : nrBody[nrBody.length - 1].Auftragsnummer;
      } else {
        prevAuftragsnummer = nrBody[nrBody.length - 1].Auftragsnummer;
      }
    } else {
      prevAuftragsnummer = new Date().getFullYear() + '-0';
    }

    let newAuftragsnummer;
    if (prevAuftragsnummer?.includes('-')) {
      const parts = prevAuftragsnummer.split('-');
      newAuftragsnummer = !isNaN(parts[1])
        ? parseInt(parts[1]) + 1
        : nrBody[nrBody.length - 1].id + 1;
    } else {
      newAuftragsnummer = nrBody[nrBody.length - 1].id + 1;
    }

    let newData;
    let gutachtenData;

    if (duplicatedAuftrag !== 0) {
      const resDup = await apiGet(`/helper/acl/auftrag/${duplicatedAuftrag}?populate=deep`);
      const dupBody = await parseJsonResponse(resDup);
      newData = { data: { ...dupBody } };
      newData.data.UN_Auftrag.Auftrag_Doc = null;
      newData.data.UN_Auftrag.Vollmacht_Doc = null;
      delete newData.data.createdAt;
      delete newData.data.id;
      gutachtenData = newData.data.gutachtens;
      delete newData.data.gutachtens;
      newData.data.Auftragsnummer = `${new Date().getFullYear()}-${newAuftragsnummer}`;
    } else {
      newData = {
        data: {
          Angebot: {},
          UN_Auftrag: {},
          Auftragsnummer: `${new Date().getFullYear()}-${newAuftragsnummer}`,
        },
      };
    }

    const response = await apiPost('/helper/acl/auftrag/', newData.data);
    if (!response.ok) throw new Error('Fehler beim Erstellen des Auftrags.');

    const { id: newAuftragID } = await parseJsonResponse(response);
    const newUrl = `/auftrag/${newAuftragID}`;

    if (duplicatedAuftrag !== 0) {
      const gutachtenPromises = gutachtenData.map((gutachten) =>
        postGutachten(newAuftragID, gutachten.id).then((res) =>
          Promise.all(gutachten.bewertungsobjekts.map((bo) => postBewertungsobjekt(res.id, bo.id)))
        )
      );
      await Promise.all(gutachtenPromises);
    } else {
      await postGutachten(newAuftragID);
    }

    navigate(newUrl);
  } catch (error) {
    console.error('Fehler beim Erstellen des Eintrags:', error);
  }
};
